import { type Icon as TablerIcon } from '@tabler/icons-react-native'
import { forwardRef, type ComponentRef } from 'react'
import { Path, Svg, type SvgProps } from 'react-native-svg'

// The Sparks brand mark — an 8-point starburst (4 cardinal + 4 diagonal arms) matching the product
// mockups. Structured like a Tabler "filled" icon (single path filled by `fill`/`color`) and typed
// as the Tabler Icon interface so it drops into `<Icon as={SparkIcon} .../>` and ProfileButton's
// `Icon` prop exactly like the @tabler icons (runtime-compatible: accepts color/size, renders SVG).
// The viewBox is tight to the star's bounds so the glyph fills its box.
const SPARK_PATH =
  'M 50 4 L 56.12 35.22 L 73.33 26.67 L 64.78 43.88 L 96 50 L 64.78 56.12 L 73.33 73.33 L 56.12 64.78 L 50 96 L 43.88 64.78 L 26.67 73.33 L 35.22 56.12 L 4 50 L 35.22 43.88 L 26.67 26.67 L 43.88 35.22 Z'

export interface SparkIconProps extends SvgProps {
  color?: string
  size?: number
}

const SparkIconBase = forwardRef<ComponentRef<typeof Svg>, SparkIconProps>(
  ({ color = 'currentColor', fill, height, size = 24, stroke, strokeWidth, width, ...rest }, ref) => (
    <Svg
      ref={ref}
      fill='none'
      height={height ?? size}
      viewBox='4 4 92 92'
      width={width ?? size}
      {...rest}
    >
      <Path
        d={SPARK_PATH}
        fill={fill ?? color}
        stroke={stroke ?? color}
        strokeWidth={strokeWidth ?? 1}
      />
    </Svg>
  )
)

SparkIconBase.displayName = 'SparkIcon'

export const SparkIcon = SparkIconBase as unknown as TablerIcon
